import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _actionMap;

import { KEY_DOWN, KEY_END, KEY_HOME, KEY_UP } from '@atlaskit/ds-lib/keycodes';
var actionMap = (_actionMap = {}, _defineProperty(_actionMap, KEY_DOWN, 'next'), _defineProperty(_actionMap, KEY_UP, 'prev'), _defineProperty(_actionMap, KEY_HOME, 'first'), _defineProperty(_actionMap, KEY_END, 'last'), _actionMap);
export default function handleFocus(refs) {
  return function (e) {
    var currentFocusedIdx = refs.findIndex(function (el) {
      var _document$activeEleme;

      return (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el);
    });
    var action = actionMap[e.key];

    switch (action) {
      case 'next':
        if (currentFocusedIdx < refs.length - 1) {
          e.preventDefault();
          refs[currentFocusedIdx + 1].focus();
        }

        break;

      case 'prev':
        if (currentFocusedIdx > 0) {
          e.preventDefault();
          refs[currentFocusedIdx - 1].focus();
        }

        break;

      case 'first':
        e.preventDefault();
        refs[0].focus();
        break;

      case 'last':
        e.preventDefault();
        refs[refs.length - 1].focus();
        break;

      default:
        return;
    }
  };
}